import { createContext, useContext } from 'react';

export const ImageContext = createContext({
  tooltipText: 'Кликните по изображению, что изменить размер',
  clickByImage: false
});

export const useImage = () => useContext(ImageContext);